var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorPicker(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 66 66",
    height: 512,
    viewBox: "0 0 66 66",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m64.99 33.67h-11.68c-.23 7-3.98 13.09-9.55 16.57l6.36 9.79c8.77-5.56 14.64-15.27 14.87-26.36z",
    fill: "#ed87c0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m64.99 33.67c-.22 11.09-6.09 20.8-14.86 26.36l-2.27-3.49c7.67-5.05 13.02-13.31 14.16-22.87z",
    fill: "#d870ad"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33.01 53.34c-5.75 0-10.93-2.4-14.63-6.24l-8.6 7.89c5.83 6.16 14.08 10.01 23.23 10.01 6.3 0 12.17-1.83 17.12-4.97l-6.36-9.79c-3.12 1.95-6.8 3.1-10.76 3.1z",
    fill: "#49cfae"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50.13 60.03c-4.95 3.14-10.82 4.97-17.12 4.97-9.15 0-17.4-3.85-23.23-10.01l2.03-1.86c5.45 4.32 12.33 6.9 19.83 6.9 5.74 0 11.12-1.51 15.78-4.17z",
    fill: "#36bb9b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33.01 12.67v-11.67s0 0-.01 0c-10.45 0-19.73 5.02-25.57 12.78l9.23 7.18c3.7-5.02 9.63-8.29 16.35-8.29z",
    fill: "#fb6e52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.68 33c0-4.52 1.49-8.67 3.98-12.05l-9.23-7.18c-4.03 5.36-6.42 12.02-6.42 19.23 0 8.52 3.34 16.26 8.77 21.99l8.6-7.89c-3.53-3.66-5.7-8.62-5.7-14.1z",
    fill: "#ffce54"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m3.01 33.5c-.28 0-.5-.22-.5-.5 0-5.94 1.71-11.69 4.93-16.63.15-.23.46-.29.69-.15.23.15.3.46.15.69-3.12 4.78-4.77 10.34-4.77 16.09 0 .28-.23.5-.5.5z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m63.86 6.7c0 1.44-.55 2.9-1.66 4.01l-5.4 5.39-8.01-8.02 5.39-5.39c2.21-2.22 5.8-2.23 8.02-.01 1.11 1.11 1.66 2.56 1.66 4.02z",
    fill: "#646d78"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m63.86 6.7c0 1.44-.55 2.9-1.66 4.01l-5.4 5.39-8.01-8.02 1.07-1.07 1.54 1.55c2.98 2.98 7.82 2.98 10.8 0 .83-.82 1.35-1.85 1.56-2.92.07.35.1.71.1 1.06z",
    fill: "#434a54"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m53.67 19.58-18.32 18.32c-1.25 1.26-2.92 2.02-4.69 2.16-1.78.14-3.44.9-4.69 2.16l-1.53 1.53c-1.09 1.08-2.93.95-3.83-.4-.66-.99-.45-2.33.4-3.18l1.45-1.45c1.26-1.26 2.03-2.93 2.16-4.7.13-1.78.9-3.44 2.16-4.7l9.46-9.47 8.85-8.85z",
    fill: "#e7e9ee"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m57.55 20.07c-.47.47-1.08.7-1.69.7s-1.22-.23-1.69-.7l-9.56-9.56c-.93-.93-.94-2.45 0-3.39.47-.47 1.08-.7 1.7-.71.61 0 1.23.24 1.69.7l9.56 9.56c.93.95.92 2.46-.01 3.4z",
    fill: "#646d78"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m57.55 20.07c-.47.47-1.08.71-1.7.71-.61 0-1.22-.24-1.69-.71l-9.56-9.55c-.53-.53-.76-1.25-.69-1.95.11.19.24.37.4.53l9.56 9.56c.47.46 1.08.7 1.69.7s1.23-.24 1.7-.7c.41-.41.63-.92.69-1.45.51.91.37 2.08-.4 2.86z",
    fill: "#434a54"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42.03 31.22-6.68 6.68c-1.25 1.26-2.92 2.02-4.69 2.16-1.78.14-3.44.9-4.69 2.16l-1.53 1.53c-1.09 1.08-2.93.95-3.83-.4-.66-.99-.45-2.33.4-3.18l1.45-1.45c1.26-1.26 2.03-2.93 2.16-4.7.13-1.78.9-3.44 2.16-4.7l9.46-9.47c.74 1.04 1.38 2.09 1.31 3.33-.06 1-.61 1.98-.4 2.96.17.77.78 1.37 1.44 1.8.66.44 1.39.76 2.01 1.25.65.53 1.15 1.24 1.43 2.03z",
    fill: "#fb6e52"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPicker);
export default __webpack_public_path__ + "static/media/color-picker.012fab6e20b0a56df0e433a2d73bb870.svg";
export { ForwardRef as ReactComponent };